const IconClass = {
    BLANK: 'sensor-blank',
    TOUCH: 'window'
};

export default class IconController {
    $onInit() {
        if (!this.iconClass) {
            this.iconClass = IconClass.BLANK;
        }
    }

    getAriaLabel() {
        return (this.iconClass.charAt(0).toUpperCase() + this.iconClass.slice(1)).split('-').join(' ');
    }
}



// WEBPACK FOOTER //
// ./app/common/icon/icon.controller.js